import { render } from "./Cards.vue?vue&type=template&id=b7d4e0c2&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=b7d4e0c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b7d4e0c2"

export default script